export const buildUserEmail = (userName: string) => {
  if (userName.includes("@")) {
    return userName
  }

  return `${userName}@${process.env.REACT_APP_DEFAULT_AUTH_DOMAIN}`
}
